import { mapActions, mapState } from "pinia";
import useDynamicComponentBuilderStore from "%/stores/dynamic-component-builder-store";
import {
  CanvasEventHandlerMixinStaging,
} from "%/dynamic-components/builder-engine/mixins/canvas-event-handler-mixin-staging";
import { CanvasStyleMixinStaging } from "%/dynamic-components/builder-engine/mixins/canvas-style-mixin-staging";
import { BrandedTextMixinStaging } from "%/dynamic-components/builder-engine/mixins/branded-text-mixin-staging";
import { DragAndDropMixinStaging } from "%/dynamic-components/builder-engine/mixins/drag-and-drop-mixin-staging";
import { ContextualMenuMixinStaging } from "%/dynamic-components/builder-engine/mixins/contextual-menu-mixin-staging";
import { useConfigurationPanelStore } from "~/stores/configuration-panel-store";
import { useCollaboratorStore } from "~/stores/collaborator-store";
import DynamicComponent from "%/dynamic-components/render-engine/classes-v2/dynamic-component";
import useFanPublicationStore from "%/stores/fan-publication-store";

export const ElementEditMixin = {
  props: {
    identifier: {
      type: String,
      required: false,
    },
    overrides: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    editMode: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  inject: ["activeComponentId"],
  mixins: [
    DragAndDropMixinStaging,
    BrandedTextMixinStaging,
    CanvasStyleMixinStaging,
    CanvasEventHandlerMixinStaging,
    ContextualMenuMixinStaging,
  ],
  computed: {
    ...mapState(useCollaboratorStore, [
      "canEditPublication",
    ]),
    dynamicComponentInstance() {
      return DynamicComponent.get(
        this.activeComponentId,
        useFanPublicationStore().publicationId,
      );
    },
    isTemplatedComponent() {
      return useDynamicComponentBuilderStore().isElementTemplatedComponent(this.identifier);
    },
    elementConfig() {
      return this.dynamicComponentInstance.getElementDefinition(
        this.identifier,
      );
    },
    configuration() {
      return this.dynamicComponentInstance.getElementById(this.identifier);
    },
    elementIsDeprecated() {
      if (!this.elementConfig) {
        return false;
      }
      return this.elementConfig.deprecated;
    },
    isRootLayout() {
      return this.dynamicComponentInstance.rootElementId === this.identifier;
    },
    isLayout() {
      return (this.$options.elementPanelSettings || {}).elementType === "layout";
    },
  },
  methods: {
    ...mapActions(useConfigurationPanelStore, [
      "createDynamicComponentFromIdentifier",
    ]),
    ...mapActions(useDynamicComponentBuilderStore, [
      "setEditorElementConfig",
    ]),
  },
};
